<template>
    <div class="member-wrap">
        <div class="member-entry">
            <template v-if="viewTeacher && viewCurator">
                <div class="member-img member-img--teacher">
                    <template v-if="userData.photo !== '' && userData.photo !== null">
                        <img :src="userData.photo" />
                    </template>
                    <template v-else>
                        <img :src="env.public_base + '/assets/images/user-image.png'" alt="">
                    </template>
                </div>
            </template>
            <template v-else>
                <div class="member-img">
                    <template v-if="userData.photo !== '' && userData.photo !== null">
                        <img :src="userData.photo" />
                    </template>
                    <template v-else>
                        <img :src="env.public_base + '/assets/images/user-image.png'" alt="">
                    </template>
                </div>
            </template>
            <div class="member-details">
                <template v-if="!viewTeacher && !viewCurator">
                    <div class="row info-list">
                        <div class="col-sm-4">
                            <div class="col-sm-12">
                                <span class="cart__id">ID {{ userData.id }}</span>
                            </div>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <div class="row info-list">
                        <div class="col-sm-4" :class="{'col-sm-6': viewTeacher}">
                            <div class="col-sm-12 my-0 mb-10">
                                <span class="member-position">{{ userData.pos }}</span>
                            </div>
                        </div>
                    </div>
                </template>
                <div class="row info-list row--carts">
                    <div class="col-sm-4" :class="{'col-sm-6': viewTeacher}">
                        <div class="col-sm-12">
                            <a  v-if="!viewTeacher && !viewCurator"
                                :href="`/chat/personal-channel/${userData.id}`"
                            ><h4>{{ userFullName }}</h4>
                            </a>
                            <h4 v-else>{{ userFullName }}</h4>

                        </div>
                        <template v-if="!viewTeacher && !viewCurator">
                            <div class="col-sm-12">
                                <strong>{{ $t('active') }}: </strong>
                                <span v-if="userData.is_active">{{ $t('yes') }}</span>
                                <span v-else>{{ $t('no') }}</span>
                            </div>
                            <div class="col-sm-12">
                                <strong>{{ $t('role') }}:</strong>
                                <span v-if="userData.role === 'billing'">{{ $t('billing_role') }}</span>
                                <span v-else-if="userData.role === 'student/billing'">{{ $t('student_billing_role') }}</span>
                                <span v-else>{{ $t('student_role') }}</span>
                            </div>
                        </template>
                        <template v-else>
                            <div class="col-sm-12">
                                <div class="member-consult">{{ userData.teacher_activity }}</div>
                                <div class="c-black member-consult">{{ userData.cons_time }}</div>
                            </div>
                        </template>
                         <div
                            v-if="viewCurator"
                            :class="{'col-sm-10': viewTeacher,'col-sm-12': !viewTeacher}"
                         >
                            <a
                                :href="`/chat/personal-channel/${userData.id}`"
                                class="btn btn-blue btn-icon icon-left"
                                style="margin-left: 0;"
                              >
                                {{ $t('chat') }}
                                <i>
                                  <img
                                    :src="env.public_base + '/assets/images/chats-icon.svg'"
                                    alt="chat"
                                  />
                                </i>
                              </a>
                        </div>
                    </div>

                    <template v-if="viewCurator">
                        <!--div class="col-sm-4 member-contacts">
                            <div class="col-sm-12">
                                <span>
                                    <img :src="env.public_base + '/assets/images/letter-icon.svg'" alt="">
                                </span>
                                <span>{{ userData.email }}</span>
                            </div>
                            <div class="col-sm-12">
                                <span>
                                    <img :src="env.public_base + '/assets/images/phone-svg.svg'" alt="">
                                </span>
                                <span>{{ userData.phone }}</span>
                            </div>
                        </div-->
                    </template>

                    <template v-else-if="!viewTeacher">
                        <div class="col-sm-4">
                            <div class="col-sm-12">
                                <strong>{{ userData.students_groups.length > 1 ? $t('groups') : $t('group') }}: </strong>
                                <span>{{ groupsFullName }}</span>
                            </div>
                            <div class="col-sm-12" v-if="false">
                                <strong>{{ $t('progress') }}:</strong>
                                <span>{{ userData.progress }}</span>
                            </div>
                            <div class="col-sm-12">
                                <strong>{{ userData.curators.length > 1 ? $t('curators') : $t('curator') }}:</strong>
                                <span>{{ curatorFullName }}</span>
                            </div>
                        </div>
                    </template>

                    <template v-if="!viewTeacher && !viewCurator && userData.is_billed">
                        <div class="col-sm-4 d-flex align-center justify-center">
                            <div class="member-control">
                                <router-link :to="`/payment/${userData.id}`" class="button button--accent button--add">{{ $t('go_to_payment') }}</router-link>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import env from '../../env'

    export default {
        props: [
            'viewTeacher',
            'viewCurator',
            'member'
        ],
        data: () => ({
            env
        }),
        computed: {
            userFullName() {
                return this.member && typeof this.member === 'object' ? this.member.last_name + ' ' + this.member.first_name + ' ' + this.member.patronymic : ''
            },
            curatorFullName() {
                let curators = [];
                this.member && typeof this.member === 'object' ? this.member.curators.forEach((e) => {
                    curators.push(e.last_name + ' ' + e.first_name + ' ' + e.patronymic)
                }) : ''
                return curators.join(', ');
            },
            groupsFullName() {
                let groups = [];
                this.member && typeof this.member === 'object' ? this.member.students_groups.forEach((e) => {
                    groups.push(e.name)
                }) : ''
                return groups.join(', ');
            },
            userData() {
                return this.member && typeof this.member === 'object' ? this.member : false;
            }
        },
        methods: {
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../../sass/variables";
    @import "../../../sass/teacherLesson";

    .member-wrap {
        padding: 0 20px;
        width: 100%;
    }

    .member-entry .member-img {
        width: 117px;
        position: relative;
        overflow: hidden;
        height: 117px;
        max-height: 117px;
    }

    .member-entry .member-img img {
        position: absolute;
        top: 50%;
        left: 50%;
        -webkit-transform: translate(-50%,-50%);
        -ms-transform: translate(-50%,-50%);
        transform: translate(-50%,-50%);
    }

    .member-entry .member-img.member-img--teacher {
        margin: -15px;
        min-width: 130px;

        img {
            max-height: 130px;
        }
    }

    .member-details .cart__id {
        font-size: 13px;
        font-weight: bold;
    }

    .member-entry .member-details h4 {
        margin: 0;
        font-size: 14px;
        color: #5C6169;
        font-weight: bold;
    }

    .member-entry {
        display: flex;
        margin: 0 0 20px 0;
        background-color: $white;
        min-height: 120px;
    }

    .member-details .info-list .col-sm-4,
    .member-details .info-list .col-sm-4 .col-sm-12 {
        margin: 0;
        padding: 0 12px;
    }

    .member-details .info-list .col-sm-4 .col-sm-12:first-child,
    .member-details .info-list .col-sm-4 .col-sm-12:not(:last-child) {
        margin-bottom: 15px;
    }

    .member-control {
        display: flex;
        align-items: flex-start;
        justify-content: center;
        padding-top: 9px;
        width: 100%;
        height: 100%;

        .button {
            padding-top: 8px;
            padding-bottom: 8px;
            min-width: 180px;
            text-align: center;
        }
    }

    .align-end {
        align-items: flex-end;
    }

    .justify-end {
        justify-content: flex-end;
    }

    .go-to-chat {
        display: flex;
        align-items: center;

        span:last-child {
            display: inline-block;
            margin-left: 12px;

            img {
                width: 22px;
            }
        }
    }

    .mb-10 {
        margin-bottom: 10px !important;
    }

    .c-black {
        color: $black-j;
    }

    .member-consult {
        font-size: 12px;
    }

    .member-contacts {

        .col-sm-12 {
            display: flex;
            align-items: center;

            span:first-child {
                display: flex;
            }
        }

        img {
            display: inline-block;
            margin-right: 10px;
            width: 14px;
        }
    }

    .btn-chat a.icon-left {
        padding: 10px 20px 10px 55px;
    }

    .btn-chat i {
        background-color: #1A8FBF;
        padding-left: 10px;
        padding-right: 10px;
    }
</style>